import React from "react";
import { testimonials } from "../../data";
import { UsersIcon } from "@heroicons/react/solid";

export default function Testimonials() {
  if (!testimonials || testimonials.length === 0) return null;

  return (
    <section id="testimonials" className="text-gray-300 bg-gray-950 body-font py-20">
      <div className="container px-5 mx-auto max-w-5xl">
        <div className="text-center mb-16">
          <UsersIcon className="w-10 h-10 inline-block mb-4 text-green-400" />
          <h2 className="sm:text-4xl text-3xl font-bold title-font mb-4 text-white">
            Client Testimonials &amp; Endorsements
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed xl:w-2/4 lg:w-3/4 mx-auto">
            What founders, directors, and partners say about collaborating on technical projects and digital design.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <div
              key={testimonial.name}
              className="bg-gray-900 p-8 rounded-2xl border border-gray-800 flex flex-col justify-between shadow-lg relative"
            >
              {/* SVG Quote Icon */}
              <div className="text-green-400/20 mb-4">
                <svg
                  className="w-10 h-10"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
                </svg>
              </div>

              <p className="leading-relaxed text-gray-300 text-base mb-6 italic">
                "{testimonial.quote}"
              </p>

              <div className="border-t border-gray-800 pt-4 flex items-center">
                <div className="w-10 h-10 rounded-full bg-green-500/20 border border-green-500/40 flex items-center justify-center text-green-400 font-bold mr-4">
                  {testimonial.name.charAt(0)}
                </div>
                <div>
                  <span className="title-font font-bold text-white text-base block">
                    {testimonial.name}
                  </span>
                  <span className="text-gray-400 text-xs">
                    {testimonial.role} &bull; {testimonial.company}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}